export const pluralise = (number: number, name: string) => (number > 1 ? `${name}s` : name);
